import { css } from 'styled-components';

// preflight-tables emits two sibling control rows before the table: entry count
// + pagination, then length menu + `buttons` slot + search. Both fragments below
// key off that order, and go on whichever element directly wraps a DataTable.

// Collapses the two rows onto one line, wrapping back apart when there's no room.
export const mergedTableControls = css`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  column-gap: 24px;
  row-gap: 4px;

  > div:nth-of-type(1) { flex: 0 0 auto; }
  > div:nth-of-type(2) { flex: 1 1 320px; }
  > table { flex-basis: 100%; }
`;

// Pairs with mergedTableControls: groups the length menu and buttons together
// on the left rather than spreading them, and pins search right.
export const MERGED_CONTROL_STYLES = {
  functionRow: { justifyContent: 'flex-start', columnGap: 16 },
  search: { container: { marginLeft: 'auto' } },
};

// The same grouping for tables that keep both rows. It has to be CSS rather
// than the `styles` prop because the library shares one style between the rows,
// and the first row's space-between is what holds pagination out to the right.
export const groupedTableControls = css`
  > div:nth-of-type(2) {
    justify-content: flex-start;
    column-gap: 16px;
  }

  > div:nth-of-type(2) > div:last-child {
    margin-left: auto;
  }
`;
